'use client'

import { ChatNotificationListener } from './ChatNotificationListener'
import { useEffect, useState } from 'react'

export const GlobalChatNotifications = () => {
  // Only load on client side to avoid hydration issues
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)

    return () => {}
  }, [])

  if (!isMounted) {
    return null
  }

  return <ChatNotificationListener />
}
